import { render, staticRenderFns } from "./CreditReductionForm.vue?vue&type=template&id=b0d4b40a&"
import script from "./CreditReductionForm.vue?vue&type=script&lang=js&"
export * from "./CreditReductionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports